module.exports = __webpack_public_path__ + "media/MRI22C.4952562b.mp3";